import { TransactionItem } from './item.model';

export enum ApproveStatus {
  Imported    = 0,
  Pending     = 1,
  SendFailed  = 2,
  Finished    = 3
}

export interface TransactionOverviewDto {
  notificationId: number;
  title:          string;
  body:           string;
  createdAt:      string;
  status:         ApproveStatus;
  storeName:      string;
}

export interface Transaction {
  id:         number;
  title:      string;
  message:    string;
  createdAt:  string;
  status:     ApproveStatus;
  store:      string;
}